import React, { useCallback, useEffect, useState } from "react";
import PostHooks from "../../Api/PostHooks";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";
import Page from "../../Components/Page";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import PageLoader from "../../Components/PageLoader";
import { Button, Card, CardContent, Grid } from "@mui/material";
import { formatDate } from "../../utils/helpers";
import TableComponent from "../../Components/TableComponent";
import UseServerTable from "../../Hooks/UseServerTable";
import { useNavigate } from "react-router-dom";

const BiReports = () => {
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [views, setViews] = useState([]);
  const [view, setView] = useState();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  //   const [loading, response, request] = FetchHook();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  //   const fetchBiReports = useCallback(async () => {
  //     try {
  //       const resp = await request({
  //         url: `get_bi_view`,
  //       });
  //     } catch (error) {
  //       const errorMessage =
  //         error.response?.data?.StatusMessage ??
  //         error.response?.data?.message ??
  //         error.message ??
  //         "An unexpected error occurred. Please try again.";

  //       setSnackbar({
  //         open: true,
  //         severity: "error",
  //         message: errorMessage,
  //       });
  //     }
  //   }, []);

  //   useEffect(() => {
  //     fetchBiReports();
  //   }, [fetchBiReports]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `get_bi_view`,
    onSuccess: (data) => {
      setViews(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "View Id",
      flex: 1,
    },
    {
      field: "name",
      headerName: "View name",
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Created at",
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (row) => (
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            // setView(row.row);
            navigate("/dashboard/bi-reports/view", {
              state: { view: row.row },
            });
          }}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Page title="BI Reports">
      <Card>
        <CardContent>
          {views && views.length <= 0 && gridProps.loading ? (
            <PageLoader />
          ) : views && views.length > 0 ? (
            <TableComponent
              data={views}
              columns={columns}
              sortModel={[
                {
                  field: "createdAt",
                  sort: "desc",
                },
              ]}
              {...gridProps}
            />
          ) : (
            <ErrorDisplay
              message="No Views Found"
              details="Please reload your page."
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default BiReports;
